import { render, staticRenderFns } from "./TalkMsgPost.vue?vue&type=template&id=ddeb2426&scoped=true"
import script from "./TalkMsgPost.vue?vue&type=script&lang=js"
export * from "./TalkMsgPost.vue?vue&type=script&lang=js"
import style0 from "./TalkMsgPost.vue?vue&type=style&index=0&id=ddeb2426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeb2426",
  null
  
)

export default component.exports